import {z} from '@hono/zod-openapi';

import {conversationUser} from '../user/conversationUser';

export const readBy = z.object({
  readAt: z.string().datetime().openapi({
    description: 'Timestamp when the user read the event',
    example: '2024-01-01T00:01:00.000Z',
  }),
  user: conversationUser.openapi({
    description: 'Details of user who read the event',
  }),
});
